function UpdateRequiredDialog() {
    this.init.apply(this, arguments);
}

UpdateRequiredDialog.$inject = [
    '$scope',
    '$mdDialog',
    'mdPanelRef',
    '$translationService',
    'AuthService',
    'installationUrl',
    '$state',
    '$Config'
];
UpdateRequiredDialog.prototype = {
    installationUrl: '',
    isLoggedIn: false,
    init: function ($scope, $mdDialog, mdPanelRef, $translationService, AuthService, installationUrl, $state, $Config) {
        $scope.vm = this;
        this.$scope = $scope;
        this.$mdDialog = $mdDialog;
        this.mdPanelRef = mdPanelRef;
        this.$translationService = $translationService;
        this.authService = AuthService;
        this.$state = $state;
        this.$Config = $Config;

        this.installationUrl = installationUrl;
        this.isLoggedIn = this.authService.isLoggedIn();
    },

    onLogoutButtonClick() {
        this.authService.logout().then(angular.bind(this, function () {
            this.close(); // close popup
            this.$state.go("internal.login"); // go to login screen
        }));
    },


    onDownloadAndInstallClick() {
        this.downloadByOpenLink(this.installationUrl);
    },

    /**
     * Open Outside in Apple Store
     * @private
     */
    downloadByOpenLink(url) {
        console.log('Download url: ' + url);
        if (window['cordova']) {
            window['cordova'].InAppBrowser.open(encodeURI(url), '_system');
        } else {
            window.open(url, '_system')
        }
    },
    
    close(){
        this.mdPanelRef.close();
    }
};


angular.module('shared.checking-new-version-dialog', []).controller('UpdateRequiredDialog', UpdateRequiredDialog);
